export default "__VITE_ASSET__1dad5769__"